import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import '../styles/Clientes.css';
import { usePermisos } from '../hooks/usePermisos';
import { usePermisosGuard } from '../hooks/usePermisosGuard';

const Prestamos = () => {
  usePermisosGuard('prestamos', 'ver');
  const navigate = useNavigate();
  const location = useLocation();
  const { codigo } = useParams(); // Obtener el código del tenant de la URL
  const { can } = usePermisos();

  // Función para construir rutas con el código del tenant
  const getRoute = (path) => {
    if (codigo) {
      return `/${codigo}${path}`;
    }
    return path;
  };

  const menuItems = [
    can('prestamos', 'crear') && { path: '/prestamos/nuevo', label: 'Nuevo', icon: '💰' },
    can('prestamos', 'aprobar') && { path: '/prestamos/reenganche', label: 'Reenganche', icon: '🔄' },
    can('prestamos', 'eliminar') && { path: '/prestamos/eliminar', label: 'Eliminar', icon: '🗑️' },
    can('prestamos', 'editar') && { path: '/prestamos/editar', label: 'Editar', icon: '✏️' },
    can('prestamos', 'eliminar') && { path: '/prestamos/eliminar-reenganche', label: 'Eliminar Reenganche', icon: '❌' },
    can('prestamos', 'ver') && { path: '/prestamos/lista', label: 'Ver Préstamos', icon: '📋' }
  ].filter(Boolean);

  const isActive = (path) => location.pathname === getRoute(path);
  const isMainPage = location.pathname === getRoute('/prestamos');

  if (!isMainPage) {
    return <Outlet />;
  }

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>💰 Préstamo</h1>
      </div>

      <div className="clientes-menu">
        {menuItems.length === 0 ? (
          <p style={{ padding: '1rem', color: '#718096' }}>
            No tienes acciones habilitadas en el módulo de préstamos.
          </p>
        ) : (
          menuItems.map((item) => (
            <button
              key={item.path}
              onClick={() => navigate(getRoute(item.path))}
              className={`menu-item ${isActive(item.path) ? 'active' : ''}`}
            >
              <span className="menu-icon">{item.icon}</span>
              <span className="menu-label">{item.label}</span>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default Prestamos;